<script setup lang="ts">
import { computed, ref } from 'vue';
import { Input } from '@/components/ui/input';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';

const props = defineProps<{
  field: string;
  dataType: string;
  data: any;
  classType: string;
}>();

const filterText = ref('');

// Field pattern: 'phone_numbers.display_string' where 'phone_numbers' is the array field
const childrenArray = computed(() => {
  const parts = props.field.split('.');
  if (parts.length !== 2 || parts[1] !== 'display_string') {
    return [];
  }
  const arrayField = parts[0];
  const arrayData = props.data[arrayField];
  return Array.isArray(arrayData) ? arrayData : [];
});

const filteredItems = computed(() => {
  if (!filterText.value.trim()) {
    return childrenArray.value;
  }
  const searchText = filterText.value.toLowerCase();
  return childrenArray.value.filter(
    (item: any) => (item?.display_string || '').toLowerCase().includes(searchText)
  );
});
</script>

<template>
  <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
    <div class="py-3 border-b px-4">
      <Input v-model="filterText" placeholder="Filter phone numbers..." />
    </div>
    <div class="flex-1 min-h-0 overflow-auto px-4">
      <Table tableClass="min-w-max table-auto">
        <TableBody>
          <template v-if="filteredItems.length > 0">
            <TableRow v-for="(item, index) in filteredItems" :key="item?.id ?? index">
              <TableCell class="break-words">
                {{ item?.display_string || '' }}
              </TableCell>
            </TableRow>
          </template>
          <TableRow v-else>
            <TableCell class="text-center text-muted-foreground py-6">
              No items found
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  </div>
</template>
